import type * as DatadogRUM from '@datadog/browser-rum';

export const initRum = async (
  config: Partial<Parameters<(typeof DatadogRUM.datadogRum)['init']>[0]> = {},
) => {
  const applicationId =
    config.applicationId || process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID;
  const clientToken =
    config.clientToken || process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENTTOKEN;

  if (!applicationId || !clientToken) {
    return;
  }

  /**
   * We do not want to inadvertently add sensitive and private information to Datadog.
   * We're more interested in broad, page-level metrics than specific interactions.
   *
   * @see https://docs.datadoghq.com/real_user_monitoring/browser/tracking_user_actions
   */
  const TRACK_INTERACTIONS = false;

  const { datadogRum } = await import('@datadog/browser-rum');

  datadogRum.init({
    applicationId,
    clientToken,
    env: process.env.NEXT_PUBLIC_DATADOG_RUM_ENV,
    site: 'datadoghq.com',
    service: process.env.NEXT_PUBLIC_DATADOG_RUM_SERVICE,
    version: process.env.NEXT_PUBLIC_DATADOG_RUM_VERSION,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    trackUserInteractions: TRACK_INTERACTIONS,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    ...config,
  });

  datadogRum.startSessionReplayRecording();
};
